var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/find-registry.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/find-registry.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n\n";
env.getTemplate("modal/modal-contents.j2", true, "core/templates/modal/find-registry.j2", false, function(t_9,_parentTemplate) {
if(t_9) { cb(t_9); return; }
parentTemplate = _parentTemplate
for(var t_8 in parentTemplate.blocks) {
context.addBlock(t_8, parentTemplate.blocks[t_8]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
output += t_12;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n    o-modal--small c-find-registry__modal\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n<form novalidate class=\"c-find-registry__form js-find-registry\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\">\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <h1 class=\"u-global-h1\">\n                ";
output += runtime.suppressValue((lineno = 17, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["registry_find-header"])), env.opts.autoescape);
output += "\n            </h1>\n\n            <p class=\"u-global-p\">\n                ";
output += runtime.suppressValue((lineno = 21, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["registry_landing-find-instructional"])), env.opts.autoescape);
output += "\n            </p>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <div class=\"c-form__field is-required ";
output += runtime.suppressValue((lineno = 32, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"findRegistry")),"messages")),"first_name")])), env.opts.autoescape);
output += "\">\n\n                <label for=\"first_name\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 35, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["registry_form-first-name"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"text\" name=\"first_name\" class=\"c-form__text\" ";
output += runtime.suppressValue((lineno = 38, colno = 89, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedField"), "validatedField", context, ["ERROR_CORE_REQUIRED_FIELD_ERROR",runtime.makeKeywordArgs({"field": (lineno = 38, colno = 134, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.modal.findRegistry.messages.first_name"]))})])), env.opts.autoescape);
output += " aria-describedby=\"first_name_error\"/>\n\n\n                <div class=\"c-form__field has-error\">\n                    <p class=\"c-form-message\">\n                        ";
output += runtime.suppressValue((lineno = 43, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"findRegistry")),"messages")),"first_name"),runtime.makeKeywordArgs({"id": "first_name"})])), env.opts.autoescape);
output += "\n                    </p>\n                </div>\n\n            </div>\n\n            <div class=\"c-form__field is-required ";
output += runtime.suppressValue((lineno = 49, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"findRegistry")),"messages")),"last_name")])), env.opts.autoescape);
output += "\">\n\n                <label for=\"last_name\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 52, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["registry_form-last-name"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"text\" name=\"last_name\" class=\"c-form__text\" ";
output += runtime.suppressValue((lineno = 55, colno = 88, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedField"), "validatedField", context, ["ERROR_CORE_REQUIRED_FIELD_ERROR",runtime.makeKeywordArgs({"field": (lineno = 55, colno = 134, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.modal.findRegistry.messages.last_name"]))})])), env.opts.autoescape);
output += " aria-describedby=\"last_name_error\"/>\n\n                <div class=\"c-form__field has-error\">\n                    <p class=\"c-form-message\">\n                        ";
output += runtime.suppressValue((lineno = 59, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"findRegistry")),"messages")),"last_name"),runtime.makeKeywordArgs({"id": "last_name"})])), env.opts.autoescape);
output += "\n                    </p>\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12 o-small--8\">\n\n            <button type=\"submit\" class=\"c-button-primary\">\n                ";
output += runtime.suppressValue((lineno = 74, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["registry_form-find-registry"])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n    </div>\n\n</form>\n\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/find-registry.j2"] , dependencies)